const styles = theme => ({
  topMarginForSlides: {
    marginTop: '11px'
  },
  sliderAreaDiv: {
    marginTop: 30
  },
  apiCards: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    padding: '20%'
  },
  card: {
    textAlign: 'left',
    margin: 'auto',
    marginBottom: '20px',
    boxShadow: 'inset -1px 0 0 0 rgba(0, 0, 0, 0.07)',
    backgroundColor: '#ffffff'
  },
  media: {
    backgroundSize: '50px',
    minHeight: 100
  },
  h2: {
    color: '#3A3A3A !important',
    fontSize: '16px',
    fontWeight: '500'
  },
  cardActions: {
    justifyContent: 'center'
  },
  btnCardAction: {
    width: '170px',
    height: '40px',
    color: '#004E98',
    textDecoration: 'underline',
  },
  txtFindMore: {
    fontFamily: 'Univia Pro',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center'
  },
  cardContent: {
    padding: '15px',
    borderBottom: '1px solid #80808040',
    minHeight: 150
  },
  link: {

    color: '#015099',
    fontSize: '22px',
    fontFamily: 'Univia Pro',
    textTransform: 'none',
    letterSpacing: '-0.6px',
    textAlign: 'center'
  },
  text: {
    fontFamily: 'Univia Pro',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#676767',
    paddingTop: '10%'
  },
  allAPIs: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2%'
  },
  btnAllAPIs: {
    width: '170px',
    height: '40px',
    borderRadius: '28.8px',
    lineHeight: '40px',
    backgroundColor: 'rgb(9,80,153)',
    background: 'linear-gradient(0deg, rgba(9,80,153,1) 0%, rgba(6,58,112,1) 100%)'
  },
  txtAllAPIs: {
    fontFamily: 'Univia Pro',
    fontSize: '14px',
    fontWeight: '500',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#e01e1e',
    marginBottom: '5%'
  },
  label: {
    fontSize: '14px',
    paddingTop: '4px'
  }

});

export default styles;
